export * from './avatar-upload.component';